import { css, html, LitElement } from "lit"

export default class PageCommentCaMarche extends LitElement {
  static styles = css`
    ol {
        display: flex;
        flex-direction: column;
        gap: 10px;
        list-style: none; /* On cache les numéros standards */
        counter-reset: my-counter; /* On initialise le compteur */
        padding-left: 40px;
    }

    li {
        counter-increment: my-counter; /* On incrémente à chaque li */
        position: relative;
        margin-bottom: 15px;
    }

    li::before {
        content: counter(my-counter); /* On affiche la valeur */
        
        /* Stylisation du cercle */
        position: absolute;
        left: -40px;
        top: 30%;
        transform: translateY(-50%);
        
        background-color: var(--couleur-500);
        color: white;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        
        /* Alignement du texte dans le cercle */
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        font-weight: bold;
    }
    `

  render() {
    return html`
            <h1>Comment ça marche ?</h1>
            <ol>
                <li><strong>Inscription :</strong> Créez un compte en utilisant votre adresse e-mail ou connectez-vous avec votre compte Google, Microsoft ou Discord. Acceptez les notifications si vous désirez savoir que quelqu'un vous a envoyé un message.</li>
                <li><strong>Personnalisation du pseudo :</strong> Personnalisez votre profil en modifiant votre pseudo en cliquant dessus. Nous vous conseillons de mettre votre pseudo de jeu.</li>
                <li><strong>Personnaliser votre recherche de pokémon :</strong> Choisissez un pokémon que vous souhaitez échanger et définissez vos préférences de recherche (shiney, parfait, chanceux...).</li>
                <li><strong>Créer ou rejoindre une communauté :</strong> Invitez d'autres joueurs à rejoindre votre communauté pour faciliter les échanges de pokémons.</li>
                <li><strong>Visualiser les recherches des autres utilisateurs :</strong> Parcourez les recherches des autres utilisateurs pour trouver des partenaires d'échange compatibles avec vos pokémons.</li>
                <li><strong>Échanger des pokémons :</strong> Une fois que vous avez trouvé un partenaire d'échange compatible, vous pouvez organiser l'échange de vos pokémons en lui envoyant un message.</li>
            </ol>

            <aside aria-label="Note importante">
                <strong>Attention :</strong> les 10 derniers messages d'une conversation sont gardés. Au delà, tous les messages de plus de 1 semaine sont automatiquement supprimés pour préserver votre vie privée et éviter l'accumulation de données inutiles. Pensez à sauvegarder les informations importantes avant qu'elles ne soient effacées !
            </aside>
            <p>Si vous avez des questions ou besoin d'aide, n'hésitez pas à consulter <a href="/faq">notre FAQ</a> ou à me contacter directement <a href="https://discord.com/users/342627083463426049" target="_blank" rel="noopener noreferrer">par mp sur Discord</a>.</p>
        `
  }
}
customElements.define("p-page-comment-ca-marche", PageCommentCaMarche)
